import React, { useState } from "react";
import Modal from "../../../components/ui/Modal/Modal";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import ConfirmationModal from "./ConfirmationPopup";
import DeliveryCompleteModal from "./DeliveryCompleteModal";
import QRModal from "./QRModal";
import InvoiceEditModal from "./InvoiceEditModal";

const TableStepper = (props) => {
  const { filteredItems, image, dataQr } = props;
  const totalSteps = 5;
  const [closeEditInvoice, setCloseEditInvoice] = useState(false);

  const getStepLabel = (index) => {
    const stepLabels = [
      "불량접수",
      "불량접수 확인",
      "물품배송(반송)",
      "배송중",
      "배송완료",
    ];
    return stepLabels[index];
  };

  const renderStepIcon = (index, item) => {
    const isCancelReturned = item.isCancel === "returned";
    if (
      (isCancelReturned && index > 0 && index < 4) ||
      (!isCancelReturned && index > 0)
    ) {
      return (
        <div>
          <ChevronRightIcon className="w-4" />
        </div>
      );
    }
    return null;
  };

  const renderStepButton = (step, label) => {
    return (
      <Modal
        maxWidth={step === 1 ? "max-w-[29rem]" : "max-w-[25.3rem]"}
        widthButton="w-full py-1.5 mx-2"
        widthSubmitButton="w-full py-1.5 mx-2"
        title={step === 1 && `불량접수 확인`}
        hasClose={true}
        hasCancel={false}
        cancelText="전체 다운로드"
        submitText="불량접수 확인"
        paddingTitle={`px-4 pt-4`}
        hasSubmit={false}
        onSubmit={() => {}}
        description={
          step === 1 ? (
            <ConfirmationModal isDetail={false} image={image} />
          ) : (
            <DeliveryCompleteModal />
          )
        }
      >
        <button
          disabled={step === 3 || step === 5}
          className={`${
            step === 3 || step === 5
              ? "text-dark-grey border border-disable-grey bg-disable-grey"
              : step === 4
              ? "bg-background-blue border border-background-blue text-white"
              : "bg-backdrop-red border border-backdrop-red text-white"
          }  rounded-[4px] px-3 py-0.5`}
        >
          {label}
        </button>
      </Modal>
    );
  };

  const renderDeliveryDetails = (item) => {
    if (item.steps === 4 || item.steps === 5) {
      return (
        <div>
          <p>전체 배송</p>
          <Modal
            maxWidth="max-w-[26rem]"
            padding="p-0"
            hasCancel={false}
            hasSubmit={false}
            description={
              <div className="px-5 pt-2 pb-1">
                송장번호를 수정하시겠습니까?
                <br />
                1. 수정할 경우 - '송장번호 수정' 선택
                <br />
                2. 배송추적 확인할 경우 - '배송추적 확인' 선택
                <div className="-mb-2.5 flex justify-end mt-3">
                  <Modal
                    padding="p-0"
                    maxWidth="max-w-[50rem]"
                    hasCancel={false}
                    hasSubmit={false}
                    triggerClose={closeEditInvoice}
                    description={
                      <InvoiceEditModal setCloseModal={setCloseEditInvoice} />
                    }
                  >
                    <button className="bg-primary-blue mr-2 px-3 py-1 rounded-[4px] text-white border border-primary-blue">
                      송장번호 수정
                    </button>
                  </Modal>

                  <button className="bg-primary-blue px-3 text-white rounded-[4px] border border-primary-blue">
                    배송추적 확인
                  </button>
                </div>
              </div>
            }
          >
            <button className="text-[10px] border border-secondary-grey text-dark-grey mt-1.5 rounded-[4px] px-1.5 py-0.5">
              배송추적
            </button>
          </Modal>
        </div>
      );
    }
    return null;
  };

  let totalQty = 0;
  filteredItems.forEach((item) => {
    totalQty += item.receivedQty;
  });

  return (
    <table className="w-full text-center mt-2 text-[12px]">
      <thead>
        <tr className="bg-input-grey">
          <th className="border border-disable-grey p-2">번호</th>
          <th className="border border-disable-grey p-2">카테고리</th>
          <th className="border border-disable-grey p-2">상품명</th>
          <th className="border border-disable-grey p-2">상품코드(REF)</th>
          <th className="border border-disable-grey p-2">접수 수량</th>
          <th className="border border-disable-grey p-2">발송 수량</th>
          <th className="border w-32 border-disable-grey p-2">
            택배사/송장번호
          </th>
          <th className="border border-disable-grey p-1.5">배송 상태</th>
          <th className="border border-disable-grey p-1.5">비고</th>
        </tr>
      </thead>
      <tbody>
        {filteredItems.map((item, index) => (
          <React.Fragment key={item.id}>
            <tr>
              <td
                rowSpan={2}
                className="h-40 px-4 w-12 border border-light-grey py-8 text-center"
              >
                {index + 1}
              </td>
              <td className="px-4 border border-light-grey text-center">
                {item.category}
              </td>
              <td className="border border-light-grey px-8 text-center">
                {item.name}
              </td>
              <td className="border border-light-grey text-center">
                {item.ref}
              </td>
              <td className="border border-light-grey text-center">
                {item.receivedQty}
              </td>
              <td className="border border-light-grey px-4 text-center">0</td>
              <td className="border border-light-grey text-center">
                {item.steps === 3 && (
                  <Modal
                    padding="p-0"
                    hasSubmit={false}
                    hasCancel={false}
                    maxWidth="max-w-[48rem]"
                    description={<QRModal dataQr={dataQr} />}
                  >
                    <button className="border-background-blue border px-5 py-0.5 text-background-blue rounded-[4px]">
                      등록
                    </button>
                  </Modal>
                )}
                {(item.steps === 4 || item.steps === 5) && (
                  <div>
                    택배사명1
                    <br />
                    1234567890
                  </div>
                )}
              </td>
              <td className="w-20 border border-light-grey text-center">
                {renderDeliveryDetails(item)}
              </td>
              <td className="px-1 w-24 border border-light-grey text-center">
                <Modal
                  maxWidth={"max-w-[29rem]"}
                  widthButton="w-full py-1.5 mx-2"
                  widthSubmitButton="w-full py-1.5 mx-2"
                  title={`${
                    item.steps === 5
                      ? "불량접수 상세 내역"
                      : "불량접수 상세 내역"
                  } `}
                  hasClose={true}
                  hasCancel={false}
                  cancelText="전체 다운로드"
                  submitText="불량접수 확인"
                  paddingTitle={`px-4 pt-4`}
                  hasSubmit={false}
                  onSubmit={() => {}}
                  description={
                    <ConfirmationModal
                      steps={item.steps === 5}
                      isDetail={true}
                      image={image}
                    />
                  }
                >
                  <button className="text-dark-grey rounded-[4px] px-2.5 py-0.5 border border-secondary-grey">
                    접수상세
                  </button>
                </Modal>
              </td>
            </tr>
            <tr>
              <td
                colSpan={8}
                className="w-20 h-[4rem] border border-disable-grey bg-drop-blue text-center"
              >
                <div className="flex justify-between items-center px-4">
                  <div className="flex space-x-5 font-bold">
                    {[...Array(totalSteps)].map((_, index) => (
                      <React.Fragment key={index}>
                        {renderStepIcon(index, item)}
                        <p
                          className={`${
                            item.steps >= index + 1
                              ? "font-bold text-black"
                              : "font-bold text-secondary-grey"
                          }`}
                        >
                          {getStepLabel(index)}
                        </p>
                      </React.Fragment>
                    ))}
                  </div>
                  <div>
                    {item.steps === 1 &&
                      renderStepButton(item.steps, "불량접수 요청")}
                    {item.steps === 3 &&
                      renderStepButton(item.steps, "불량접수 확인")}
                    {item.steps === 4 &&
                      renderStepButton(item.steps, "불량접수 배송완료")}
                    {item.steps === 5 &&
                      renderStepButton(item.steps, "배송완료")}
                  </div>
                </div>
              </td>
            </tr>
            {index + 1 === filteredItems.length && (
              <tr className="border font-bold border-disable-grey bg-input-grey">
                <td colSpan={3} className="border py-2">
                  합계
                </td>
                <td className="border"></td>
                <td className="border">{totalQty}</td>
                <td className="border">0</td>
                <td className="border"></td>
                <td className="border"></td>
                <td className="border"></td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default TableStepper;
